import React, { useEffect, useState } from "react"
import { Symbols } from "@tenforce/toolbox-fontmap"
import {
    Block,
    Item,
    ItemBlock,
    Part,
    Selector,
} from "@tenforce/toolbox-selector-react"
import ContextMenu from "../../../../common/contextmenu/components/ContextMenu"

import ShareButton from "../../../../common/resource/ShareButton"
import { useAppSelector } from "../../../../../hooks"

import BookmarkButton from "../../../../dataapi-bookmark/component/BookmarkButton"
import ContextMenuAction from "../../../../common/contextmenu/components/ContextMenuAction"
import {
    findDeleteButton,
    findOptionalCustomButtons,
    findOptionalStandardButtons,
    findPrimaryButtons,
} from "./helper"

import "./../Header.scss"
import { Labels } from "../../../../../util/Translations"
import { IButton } from "../../../../common/contextmenu"

const ItemDetailHeaderActions: React.FC = () => {
    const { item, pageHeader, buttons } = useAppSelector(
        (state) => state.itemDetail,
    )

    const [isContextModalShown, setIsContextModalShown] = useState(false)
    const [optionalStandardActionButtons, setOptionalStandardActionButtons] =
        useState<IButton[]>([])
    const [optionalCustomActionButtons, setOptionalCustomActionButtons] =
        useState<IButton[]>([])

    const [deleteButton, setDeleteButton] = useState<IButton | null>(null)
    const [primaryActionButtons, setPrimaryActionButtons] = useState<IButton[]>(
        [],
    )

    useEffect(() => {
        setDeleteButton(findDeleteButton(buttons))
        setPrimaryActionButtons(findPrimaryButtons(buttons))
        setOptionalStandardActionButtons(findOptionalStandardButtons(buttons))
        setOptionalCustomActionButtons(findOptionalCustomButtons(buttons))
    }, [buttons])

    const { ItemDetailsCopiedToClipboard, ShareButtonTooltip } = Labels
    const bookmarkButtonId = "HEADER_BOOKMARK_BUTTON"

    return (
        <>
            <div className="header">
                {primaryActionButtons.map((button) => (
                    <ContextMenuAction
                        button={button}
                        key={button.uuid}
                        executeCallAction={(): void => {
                            console.info("not implemented")
                        }}
                    />
                ))}
            </div>
            <Item data-testid="status" isSelected={true}>
                <Block>
                    <Part>{item.status?.label}</Part>
                </Block>
            </Item>

            <ShareButton
                buttonId={`shareButton${item.id}`}
                resourceTitle={`${item.number ? `(${item.number}) ` : ""}${
                    pageHeader.title?.value
                }`}
                showCaption={false}
                successMessage={ItemDetailsCopiedToClipboard}
                tooltip={ShareButtonTooltip}
                url={window.location.href}
            />
            {item.id && (
                <BookmarkButton
                    bookmarkButtonId={bookmarkButtonId}
                    resourceId={item.id}
                    resourceType="Item"
                />
            )}
            {/* placeholder */}
            <ContextMenu
                buttonId="optionalHeaderButtonsButton"
                hideModal={(): void => {
                    setIsContextModalShown(false)
                }}
                isModalShown={isContextModalShown}
                modalId="optionalHeaderButtonsModal"
                showModal={(): void => {
                    setIsContextModalShown(true)
                }}
            >
                <div className="tw-py-2">
                    {optionalCustomActionButtons.map((button) => (
                        <ContextMenuAction
                            button={button}
                            executeCallAction={(): void => {
                                console.log("not implemented")
                            }}
                            extraClasses="tw-py-2 tw-px-4"
                            key={button.uuid}
                        />
                    ))}
                    {optionalCustomActionButtons.length > 0 && (
                        <div className="separator-line is-dotted is-dimmed tw-py-2" />
                    )}
                    {optionalStandardActionButtons.map((button) => (
                        <ContextMenuAction
                            button={button}
                            executeCallAction={(): void => {
                                console.log("not implemented")
                            }}
                            extraClasses="tw-py-2 tw-px-4"
                            key={button.uuid}
                        />
                    ))}
                    {!!deleteButton && (
                        <>
                            <div className="separator-line is-dotted is-dimmed tw-py-2" />
                            <ContextMenuAction
                                button={deleteButton}
                                executeCallAction={(): void => {
                                    console.log("not implemented")
                                }}
                                extraClasses="tw-py-2 tw-px-4"
                                key={deleteButton.uuid}
                            />
                        </>
                    )}
                </div>
            </ContextMenu>
            {/* placeholder */}
            <Selector isSingleSelect={false} isExpanded={true}>
                <ItemBlock>
                    <Part>{Symbols.Process}</Part>
                </ItemBlock>
                <ItemBlock>
                    <Part>{Symbols.CommentsAndAttachments}</Part>
                </ItemBlock>
            </Selector>
        </>
    )
}
export default ItemDetailHeaderActions
